import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 lg:py-24 bg-ink-50" data-id="element-78">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2rem] p-8 md:p-12 border border-ink-100 text-center shadow-card relative overflow-hidden" data-id="element-80">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-80 h-80 bg-brand-50 rounded-full blur-3xl pointer-events-none" data-id="element-81"></div>

          <div className="relative z-10" data-id="element-82">
            <div className="w-24 h-24 mx-auto bg-brand-500 text-white rounded-full flex items-center justify-center shadow-cta mb-6" data-id="element-83">
              <ShieldCheck className="w-12 h-12" data-id="element-84" />
            </div>

            <div className="inline-block text-brand-700 font-bold text-xs uppercase tracking-widest mb-3 px-3 py-1 bg-brand-50 rounded-full border border-brand-100" data-id="element-85">
              Compra protegida
            </div>

            <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-5 leading-tight tracking-tight" data-id="element-86">
              Probalo durante{' '}
              <span className="text-brand-500" data-id="element-87">7 días sin riesgo</span>
            </h2>

            <p className="text-lg md:text-xl text-ink-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-88">
              Si sentís que no es para vos, te devolvemos el{' '}
              <strong className="text-ink-900" data-id="element-89">100% de tu dinero</strong>. Sin
              preguntas, sin vueltas.
            </p>

            <div className="flex flex-wrap justify-center gap-3" data-id="element-90">
              {['Sin preguntas', 'Sin vueltas', 'Sin letra chica'].map((t, i) => <div key={i} className="flex items-center gap-2 bg-ink-50 px-4 py-2 rounded-full text-sm font-bold text-ink-800 border border-ink-100" data-id="element-91">
                    <Check className="w-4 h-4 text-brand-500" strokeWidth={3} data-id="element-92" />{' '}
                    {t}
                  </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}